/**
 * Mission API utilities
 */

import { MissionApiResponse } from '@/lib/mappers/missionMapper';
import { fetchApi } from './client';

/**
 * Fetches mission data from the API
 */
export async function fetchMissionData(): Promise<MissionApiResponse> {
  return fetchApi<MissionApiResponse>('/api/mission');
}

/**
 * Server-side function to get mission data
 */
export async function getMissionData(): Promise<MissionApiResponse> {
  try {
    // During build time, import the data directly instead of making HTTP requests
    if (process.env.NODE_ENV === 'production' || process.env.NEXT_PHASE === 'phase-production-build') {
      const missionData = await import('@/data/mission.json');
      return missionData.default;
    }
    
    // During development, try to fetch from API
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000';
    const response = await fetch(`${baseUrl}/api/mission`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch mission data: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching mission data server-side:', error);
    // Fallback to direct import if fetch fails
    try {
      const missionData = await import('@/data/mission.json');
      return missionData.default;
    } catch (importError) {
      console.error('Error importing mission data:', importError);
      throw error;
    }
  }
}
